import { render, staticRenderFns } from "./DownloadAudio.vue?vue&type=template&id=51bedd54&"
import script from "./DownloadAudio.vue?vue&type=script&lang=js&"
export * from "./DownloadAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports